import moment from 'moment';
import Top    from './TopPart';
import Bottom from './BottomPart';
import inlineQuoteStyles from '../inlineQuoteStyles';
import replyHeader from '../replyHeader';


moment.locale('de');


const baseURL = window.location.origin;

const emailParse = function (email, locale) {
    if (email) {
        let htmlText = replyHeader(email, locale);

        if (email.textHtml) {

            let content = new DOMParser().parseFromString(email.textHtml, 'text/html');

            //     Removing base because it interferes with our js code   <base href="some_url">
            // TODO - this will break the email links - find a better solution
            htmlText += '<div dir="ltr"><br></div>' + inlineQuoteStyles(content);

            //clean up old wrong code
            /*htmlText = htmlText.replace(
                new RegExp('\.\./\.\./', 'g'),
                '/'
            );*/

            if(!email.attachments) {
                email.attachments = [];
            }
            for (const attachment of email.attachments) {
                if ((attachment.disposition === 'inline' || !attachment.disposition) && attachment.type === 'image') {
                    htmlText = htmlText.replace(
                        new RegExp('cid:' + attachment.id, 'g'),
                        '/files/' + attachment.filePath
                    );
                }
            }


        } else {
            htmlText += '<div dir="ltr"><br></div>' + email.textPlain;
        }

        return htmlText;

    } else {
        return '';
    }
};


export default function (body = '', phone = '', email = null, locale = 'de_DE') {
    return Top + `
    <div class=WordSection1>




<!-- bodyContentStart --><p class=MsoNormal><a name="_MailAutoSig"><span style='mso-fareast-language:DE'>${body}</span></p><!-- bodyContentEnd -->

<p class=MsoNormal align=left style='text-align:left'><span style='font-size:
11.0pt;color:#1F497D;mso-fareast-language:DE'><img border=0 width=264 height=109
src="/clientSpecific/email/image001.jpg"
style='1.133in;width:2.75in' v:shapes="Grafik_x0020_2"></span></p>


</div>
   ` +

        emailParse(email, locale) +

        Bottom;
}
